import React, { useState, useEffect } from "react"
import Grid from "@material-ui/core/Grid"
import Layout from "../components/layout"
import axios from "axios"
import Loading from "./loading"
import PremiumServices from "../components/Sidebar/PremiumServices"
import Seo from "../components/seo"
import Button from '@material-ui/core/Button';
import useMediaQuery from "@material-ui/core/useMediaQuery"


function pad(n) {
  return n < 10 ? "0" + n : n
}

const DropDown = props => {
  var today = new Date()
  today.setDate(1);
  let currentYear = today.getFullYear()
  today.setMonth(today.getMonth() - 1)
  let table = []

  for (let i = 0; i < 12; i++) {
    let children = []
    var month = new Date(today.setMonth(today.getMonth() + 1))
    children.push(
      month.getFullYear().toString() + pad(month.getMonth() + 1).toString()
    )
    children.push(
      month.toLocaleDateString("en-GB", { month: "long" }) +
        (month.getFullYear() !== currentYear
          ? " " + month.getFullYear().toString()
          : "")
    )
    table.push(children)
  }

  const handleClick = event => {
    props.handleDropDownChange(event.target.value)
  }

  return (
    <React.Fragment>
      {
      //eslint-disable-next-line
      }<label 
        htmlFor="defaultIndex"
        style={{ marginRight: "5px", fontWeight: "bold" }}
      >
        Selected month:
        </label> 
      <select
        style={{ fontSize: "18px", fontFamily: "proxima-nova,sans-serif" }}
        id="defaultIndex"
        defaultValue={props.currentMonth} 
        onChange={handleClick}
        onBlur={handleClick}
      >
        {table.map((x, y) => (
          <option key={y} value={x[0]}>
            {x[1]}
          </option>
        ))}
      </select>
    </React.Fragment>
  )
}

const TideRow = props => {
  const tableMenu = useMediaQuery("(min-width: 778px)")
  let now = new Date()
  let today = new Date(props.date)
  let day = today.getDay()

  let isWeekend = false
  if (day === 6 || day === 0) isWeekend = true

  let weekendClass = ""
  let weekendClassTimes = "TidesTime"

  if (isWeekend) {
    weekendClass = "Weekend"
    weekendClassTimes = "TidesTime Weekend"
  }

  let currentDay = {}

  if (today.getDate() === now.getDate() && today.getMonth() === now.getMonth())
    currentDay = { color: "#b60011" }

  return (
    <tr>
      <td className={weekendClass}>
        <span style={currentDay}>{props.formattedDate}</span>
      </td>
      <td style={tableMenu ? { paddingLeft: "100px" } : {}} className={weekendClassTimes}>
        <span style={currentDay}>{props.rise}</span>
      </td>
      <td style={tableMenu ? { paddingLeft: "100px" } : {}} className={weekendClassTimes}>
        <span style={currentDay}>{props.set}</span>
      </td>
    </tr>
  )
}

const SunriseSunset = () => {
  const [data, setData] = useState([])
  const [month, setMonth] = useState("")
  const [url, setUrl] = useState(process.env.MET_SUNRISE)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [pageTitle, setPageTitle] = useState("")

  useEffect(() => {
    const fetchData = async () => {
      setError(false)
      setLoading(true)
      try {
        const result = await axios(url + "&date=" + month)
        if (url.length && url !== null) {
          setData(result.data)
        } else {
          setData([])
        }
      }
     catch (error) {
        setError(true)
        console.log(error)
      }
      if (month !== "") setPageTitle("Jersey Airport sunrise and sunset " + month.substring(0, 4))
      else setPageTitle("Jersey Airport sunrise and sunset " 
      + new Date().getFullYear().toString()
      )

      setLoading(false)
    }
    fetchData()
  }, [month, url]) // eslint-disable-line

  return (
    <React.Fragment>
      <Layout>
      <Seo title="Sunrise sunset St. Helier" description="Dates and times for sunrise and sunset in Jersey." />
      <div className="forecastAutoMargin">
      <Grid item xs={12} sm={12} md={8} lg={8} className="menuTitle" style={{paddingLeft:0}}>
                  <h1>
                  {pageTitle}
                  </h1>                  
      </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={8} lg={8}>
            {error ? (
                <div>
                  <p style={{ color: "#bf0d0d" }}>
                    Sorry, the sunrise sunset information is not available at
                    the moment. Please check back later.
                  </p>
                  <div style={{textAlign:"center"}}><Button className="resendButton" onClick={() => setUrl(process.env.MET_SUNRISE) }>Try again</Button></div>
                </div>
              ) : (
                <React.Fragment>
                  {loading ? (
                    <Loading />
                  ) : (
                    <React.Fragment>
                     
                     <DropDown pageTitleDD={"this"} currentMonth={month}
                handleDropDownChange={DropDownValue =>
                  setMonth(DropDownValue)
                }
                noErrorStatus={error}
              />
              <div>
                <p>
                  All times are local. An hour has already been added for BST
                  where applicable.
                </p>
              
                  <table className="generalTableStyle">
                    <thead style={{ backgroundColor: "#b60011" }}>
                      <tr>
                        <th>Date</th>
                        <th style={{ textAlign: "right" }}>Sunrise</th>
                        <th style={{ textAlign: "right" }}>Sunset</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map(result => (<TideRow key={result.date} {...result} />))}
                    </tbody>
                  </table>
             
              </div>


                    </React.Fragment>
                  )}
                </React.Fragment>
              )}
      
            </Grid>
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <PremiumServices />
                </Grid>
          </Grid>
        </div>
      </Layout>
    </React.Fragment>
  )
}
export default SunriseSunset;
